import { Tooltip } from "@mui/material";
import React from "react";

/**
 * A component which wraps a tooltip wrapped around some text.
 * @param props
 * @returns 
 */
export function TextWithTooltip(props: any) {
    const {text, tip} = props;
    return (
        <Tooltip title={''+tip} arrow><span>{text}</span></Tooltip>
    )
}
